module.exports = __webpack_public_path__ + "img/example-map.09064b4a.png";